import { Routes } from '@angular/router';
import { CustomerSupportSigninManager } from './services/signin-manager.service';
import { SigninManager } from 'sham-components/shared/auth';
import { dashboardGuestGuard, dashboardRoleGuard } from 'sham-components/services';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [dashboardGuestGuard('Accountant', ['/app'])],
    loadComponent: () =>
      import('./features/auth/signin/signin').then((x) => x.Signin),
    providers: [{ provide: SigninManager, useClass: CustomerSupportSigninManager }],
  },
  { path: 'signin', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'app',
    canActivate: [dashboardRoleGuard('Accountant', ['/login'])],
    canActivateChild: [dashboardRoleGuard('Accountant', ['/login'])],
    loadComponent: () =>
      import('./layouts/dashboard/dashboard').then((x) => x.Dashboard),
    loadChildren: () => import('./shared/dashboard-routes'),
  },

  { pathMatch: 'full', path: '', redirectTo: '/login' },
  { path: '**', redirectTo: '/login' },
];
